import React from 'react'

// reactstrap components
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap"

export default function (props) {

  const {
    data,
    onClose
  } = props

  const close = () => {
    if (onClose) {
      return onClose()
    }
  }

  return (
    <Modal isOpen={data.show} className='attach-modal modal-dialog-centered'>
      <ModalHeader>
        {
          data.title
        }
      </ModalHeader>
      <ModalBody>
        {
          <img src={data.url || ''} alt={data.title} className='attach-img'></img>
        }
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={ () => close() }>Cerrar</Button>
      </ModalFooter>
    </Modal>
  )
}